<dsd-place-bubble
  [show]="isVisible"
  showDelayDuration="0"
  placement="bottom-end"
  [dsdPlaceBubbleHide]="deleteNotification()"
  id="{{ 'infobulle-' + feature }}"
>
  <ng-content></ng-content>
  <span slot="title" id="titre-infobulle" class="title">{{ parametresTraduction.titre | translate }}</span>
  <span
    slot="description"
    id="texte-infobulle"
    class="text"
    [innerHTML]="parametresTraduction.texte | translate"
  ></span>
</dsd-place-bubble>
